<template>
  <span class="sa-badge" :class="variantClass">{{ label }}</span>
</template>

<script>
import { systemName } from '@/utils/superAdmin/formatters';

export default {
  name: 'SystemBadge',
  props: {
    typeSystem: { type: [Number, String], required: true },
  },
  computed: {
    label() {
      return systemName(this.typeSystem);
    },
    variantClass() {
      return Number(this.typeSystem) === 2 ? 'sa-badge--weflix' : 'sa-badge--weeduc';
    },
  },
};
</script>

<style scoped>
.sa-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.18rem 0.45rem;
  border-radius: 6px;
  font-size: 0.6875rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  white-space: nowrap;
}

.sa-badge--weeduc {
  background: #f0edfa;
  color: #250891;
}

.sa-badge--weflix {
  background: #e8f9fb;
  color: #0e8a92;
}
</style>
